export default {
  getDocumentTemplate: (state) => state.documentTemplate,
};
